import React from 'react';
import PropTypes from 'prop-types';

import * as styled from './styles';

function PersonBubbleItem({ name, title, imageExtended: { image }, onClick }) {
  return (
    <styled.PersonBubbleItem onClick={onClick}>
      <styled.ImageWrapper>
        <styled.Image fluid={image.asset.fluid} altText={name} />
      </styled.ImageWrapper>
      <styled.Name levels={[300, 300]}>{name}</styled.Name>
      <styled.Title levels={[400, 400]}>{title}</styled.Title>
    </styled.PersonBubbleItem>
  );
}

PersonBubbleItem.propTypes = {
  name: PropTypes.string,
  email: PropTypes.string,
  title: PropTypes.string,
  department: PropTypes.string,
  image: PropTypes.object,
  yearAppointed: PropTypes.number,
  onClick: PropTypes.func,
};

export default PersonBubbleItem;
